export enum SearchOperator {
  Equal = '==',
  In = '=in=',
}
